import { HttpInterceptorFn } from '@angular/common/http';
import { getStoredToken } from '../services/token.storage';

/** Ajoute le JWT (Bearer) stocké au header de chaque requête sortante. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = getStoredToken();
  if (!token) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
